import { render, staticRenderFns } from "./ViewCompetitorsComponent.vue?vue&type=template&id=26830e02&"
import script from "./ViewCompetitorsComponent.vue?vue&type=script&lang=js&"
export * from "./ViewCompetitorsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewCompetitorsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports